import { createSlice } from "@reduxjs/toolkit";
import { fetchAmenitiesList, fetchAmenityCheckList, fetchDeleteAmenity, fetchDeleteParkingOptions, fetchParkingOptionsCheckList, fetchParkingOptionsList, fetchUpdateAmenitiesList, fetchUpdateParkingOptionsList } from "./AmenitiesActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const practiceAminitiesList = createSlice({
  name: "practiceAminitiesList",
  initialState: {
    isAminityLoading: false,
    amenityData: [],
    aminityError: null,
    aminityErrorMsg: "",
    amenityFetchError: null,
    amenityFetchErrorMsg: ""
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAmenitiesList.pending, (state) => {
        state.isAminityLoading = true;
        state.amenityFetchError = null;
      })
      .addCase(fetchAmenitiesList.fulfilled, (state, action) => {
        state.isAminityLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data.metadata?.outcome.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.amenityFetchError = false;
            state.amenityData = [];
          }
          else {
            state.amenityFetchError = true;
            state.amenityFetchErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.amenityFetchError = false;
          state.amenityData = action.payload.data.data.practiceAmenityResponseDTO;
        }
      })
      .addCase(fetchAmenitiesList.rejected, (state, action) => {
        state.isAminityLoading = false;
        state.amenityFetchError = action.error.message;
      })
      .addCase(fetchUpdateAmenitiesList.pending, (state) => {
        state.isAminityLoading = true;
        state.aminityError = null;
      })
      .addCase(fetchUpdateAmenitiesList.fulfilled, (state, action) => {
        state.isAminityLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data.metadata?.outcome.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.aminityError = false;
            state.amenityData = [];
          }
          else {
            state.aminityError = true;
            state.aminityErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.aminityError = false;
          state.amenityData = action.payload.data.data.practiceAmenityResponseDTO;
        }
      })
      .addCase(fetchUpdateAmenitiesList.rejected, (state, action) => {
        state.isAminityLoading = false;
        state.aminityError = action.error.message;
      })
      .addCase(fetchDeleteAmenity.pending, (state) => {
        state.isAminityLoading = true;
        state.aminityError = null;
      })
      .addCase(fetchDeleteAmenity.fulfilled, (state, action) => {
        state.isAminityLoading = false;
        if (!action.payload.success) {
          state.aminityError = true;
          state.aminityErrorMsg = getApiErrorMessage(action.payload.status);
        }
        else {
          state.aminityError = false;
          // state.aminityErrorMsg = action.payload.data.data.practiceAmenityResponseDTO.message  
        }
      })
      .addCase(fetchDeleteAmenity.rejected, (state) => {
        state.isAminityLoading = false;
        state.aminityError = true;
        state.aminityErrorMsg = "Something Went Wrong!. Please try again later.";
      })
  },
});


const practiceParkingOptionsList = createSlice({
  name: "practiceParkingOptionsList",
  initialState: {
    isParkingOptionsLoading: false,
    parkingOptions: [],
    parkingOptionsError: null,
    parkingOptionsErrorMsg: "",
    parkingOptionsListError: null,
    parkingOptionsListErrorMsg: ""
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchParkingOptionsList.pending, (state) => {
        state.isParkingOptionsLoading = true;
        state.parkingOptionsListError = null;
      })
      .addCase(fetchParkingOptionsList.fulfilled, (state, action) => {
        state.isParkingOptionsLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data.metadata?.outcome.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.parkingOptionsListError = false;
            state.parkingOptions = [];
          }
          else {
            state.parkingOptionsListError = true;
            state.parkingOptionsListErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.parkingOptionsListError = false;
          state.parkingOptions = action.payload.data.data.practiceParkingOptionResponseDTO;
        }
      })
      .addCase(fetchParkingOptionsList.rejected, (state, action) => {
        state.isParkingOptionsLoading = false;
        state.parkingOptionsListErrorMsg = action.error.message;
      })
      .addCase(fetchUpdateParkingOptionsList.pending, (state) => {
        state.isParkingOptionsLoading = true;
        state.parkingOptionsError = null;
      })
      .addCase(fetchUpdateParkingOptionsList.fulfilled, (state, action) => {
        state.isParkingOptionsLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data.metadata?.outcome.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.parkingOptionsError = false;
            state.parkingOptions = [];
          }
          else {
            state.parkingOptionsError = true;
            state.parkingOptionsErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.parkingOptionsError = false;
          state.parkingOptions = action.payload.data.data.practiceParkingOptionResponseDTO;
        }
      })
      .addCase(fetchUpdateParkingOptionsList.rejected, (state, action) => {
        state.isParkingOptionsLoading = false;
        state.parkingOptionsError = action.error.message;
      })
      .addCase(fetchDeleteParkingOptions.pending, (state) => {
        state.isParkingOptionsLoading = true;
        state.parkingOptionsError = null;
      })
      .addCase(fetchDeleteParkingOptions.fulfilled, (state, action) => {
        state.isParkingOptionsLoading = false;
        if (!action.payload.success) {
          state.parkingOptionsError = true;
          state.parkingOptionsErrorMsg = getApiErrorMessage(action.payload.status);
        }
        else {
          state.parkingOptionsError = false;
        }
      })
      .addCase(fetchDeleteParkingOptions.rejected, (state, action) => {
        state.isParkingOptionsLoading = false;
        state.parkingOptionsError = action.error.message;
      })
  },
});


const practiceAminitiesCheckList = createSlice({
  name: "practiceAminitiesCheckList",
  initialState: {
    isAminityCheckLoading: false,
    amenityCheckData: [],
    aminityCheckError: null,
    aminityCheckErrorMsg: ""
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAmenityCheckList.pending, (state) => {
        state.isAminityCheckLoading = true;
        state.aminityCheckError = null;
      })
      .addCase(fetchAmenityCheckList.fulfilled, (state, action) => {
        state.isAminityCheckLoading = false;
        if (!action.payload.success) {
          state.aminityCheckError = true;
          state.aminityCheckErrorMsg = getApiErrorMessage(action.payload.status);
        } else {
          state.aminityCheckError = false;
          state.amenityCheckData = action.payload.data.data.amenityResponseDTO;
        }
      })
      .addCase(fetchAmenityCheckList.rejected, (state, action) => {
        state.isAminityCheckLoading = false;
        state.aminityCheckError = action.error.message;
      });
  },
});


const practiceParkingOptionsCheckList = createSlice({
  name: "practiceParkingOptionsCheckList",
  initialState: {
    isparkingOptionsCheckLoading: false,
    parkingOptionsCheckData: [],
    parkingOptionsCheckError: null,
    parkingOptionsCheckErrorMsg: ""
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchParkingOptionsCheckList.pending, (state) => {
        state.isparkingOptionsCheckLoading = true;
        state.parkingOptionsCheckError = null;
      })
      .addCase(fetchParkingOptionsCheckList.fulfilled, (state, action) => {
        state.isparkingOptionsCheckLoading = false;
        if (!action.payload.success) {
          state.parkingOptionsCheckError = true;
          state.parkingOptionsCheckErrorMsg = getApiErrorMessage(action.payload.status);
        } else {
          state.parkingOptionsCheckError = false;
          state.parkingOptionsCheckData = action.payload.data.data.parkingInformationList;
        }
      })
      .addCase(fetchParkingOptionsCheckList.rejected, (state, action) => {
        state.isparkingOptionsCheckLoading = false;
        state.parkingOptionsCheckError = action.error.message;
      });
  },
});



export const { addPracticeAmenity, deletePracticeAmenity } =
  practiceAminitiesList.actions;
export const practiceAminitiesListReducer = practiceAminitiesList.reducer;
export const practiceParkingOptionsListReducer = practiceParkingOptionsList.reducer;
export const practiceParkingOptionsCheckListReducer = practiceParkingOptionsCheckList.reducer;
export const practiceAminitiesCheckListReducer =
  practiceAminitiesCheckList.reducer;